import React, { useEffect, useRef, useState } from "react";
import TableDmhoatchatList from "./TableDmhoatchatList";
import { useDispatch, useSelector } from "react-redux";
// import Utils from "utils";
import { getAllDmhoatchat } from "store/slices/sale/danhmucSlice";
// import { PermitValue, permitKey } from "constants";
import moment from "moment";
import MeditechTablePage, { FilterComponent } from "components/table-layout";
const initSearch = {
  startDate: moment().date(-30), //.startOf("month"),
  endDate: moment().endOf("month"),
  searchText: null,
};
export const initDmhoatchat = {
  action: "initial",
  isRequired: true,
};
const DmhoatchatList = () => {
  const dispatch = useDispatch();
  const { permitList } = useSelector((state) => state.auth);
  const { allDmhoatchatList, loading } = useSelector(
    (state) => state.danhMucSale
  );
  useEffect(() => {
    reloadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const reloadData = () => {
    searchFormRef.current = { ...searchFormRef.current };
    dispatch(getAllDmhoatchat(searchFormRef.current));
  };
  const searchFormRef = useRef({ ...initSearch });
  const [searchFormData, setSearchFormData] = useState(searchFormRef.current);
  const searchHandle = (dataSearch) => {
    searchFormRef.current = { ...searchFormRef.current, ...dataSearch };
    setSearchFormData({ ...searchFormRef.current });
    reloadData();
  };

  const onRenderSearchView = () => {
    return (
      <FilterComponent
        datasource={searchFormData}
        onSearchImmediate={searchHandle}
        // renderFilterMoreView={renderFilterMoreView}
        renderInputSearch
        renderDatePicker={false}
      />
    );
  };

  // const onDeleteHandler = (id) => {
  //   // dispatch(
  //   //   DeletePhuongAnKinhDoanh({
  //   //     id: id,
  //   //     onSuccess: ({ data }) => {
  //   //       if (data.isOk) {
  //   //         reloadData();
  //   //         notification.info({
  //   //           message: "Xóa phương án kinh doanh",
  //   //           description: "Xóa phiếu thành công",
  //   //         });
  //   //       } else {
  //   //         notification.error({
  //   //           message: "Xóa phương án kinh doanh",
  //   //           description: data.description,
  //   //         });
  //   //       }
  //   //     },
  //   //   })
  //   // );
  // };

  // const onOpenDetailHandler = (id) => {
  //   // setPhuongAnId(id);
  //   // setVisibleModal(true);
  // };

  const getRightButton = (isLocked) => {
    const arr = [];
    if (isLocked) {
      // arr.push({
      //   keyName: SystemButtonSource.addBtn,
      //   title: "Thêm",
      //   showMore: false,
      //   // disable: !allowAddNew,
      // });
    }
    return arr;
  };

  const onRightTopBtnHandler = (key) => {
    // switch (key) {
    //   case SystemButtonSource.addBtn:
    //     setVisibleModal((prev) => !prev);
    //     break;
    //   default:
    //     break;
    // }
  };

  // const allowAddNew = Utils.checkPermitValue(
  //   PermitValue.them,
  //   permitList,
  //   permitKey.crm_hospital
  // );

  return (
    <>
      <MeditechTablePage
        tableTitle="DANH MỤC HOẠT CHẤT"
        btnHeaderRightSource={getRightButton(true)}
        btnHeaderRightSourceHandle={onRightTopBtnHandler}
        onRenderSearchView={onRenderSearchView}
      >
        <TableDmhoatchatList
          loading={loading}
          allDmhoatchatList={allDmhoatchatList}
          reloadData={() => reloadData()}
          permitList={permitList}
        />
      </MeditechTablePage>
    </>
  );
};

export default DmhoatchatList;
